import { render, staticRenderFns } from "./promo-create.vue?vue&type=template&id=2f2e602a&scoped=true"
import script from "./promo-create.vue?vue&type=script&lang=js"
export * from "./promo-create.vue?vue&type=script&lang=js"
import style0 from "./promo-create.vue?vue&type=style&index=0&id=2f2e602a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e602a",
  null
  
)

export default component.exports